import { IdentityProvider } from './identityProvider';
import { EntraClientConfig } from '../../EntraConfig';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export interface AuthConfig {
  provider: IdentityProvider;
  entra?: EntraClientConfig;
}

// The app renders nothing until this answers, so a hung request must fail into the Okta fallback instead.
const AUTH_CONFIG_TIMEOUT_MS = 10000;

export const getAuthConfig = () =>
  apiService.callExternalApi<AuthConfig>(
    { url: `${API_SERVER_URL}/auth/config`, method: 'GET', timeout: AUTH_CONFIG_TIMEOUT_MS },
    true
  );
